import React from 'react';
import { motion } from 'framer-motion';

function ApproachPointsSection({ approachData = [] }) {
    if (!approachData || approachData.length === 0) return null;

    return (
        <section className="w-full bg-white pb-[60px] lg:pb-[95px] relative">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">

                {/* Section Header */}
                <div className="mb-[36px] lg:mb-[52px]">
                    <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-2.5">
                        Implementation Scope
                    </p>
                    <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] leading-[1.2] tracking-tight">
                        Approach & Capabilities
                    </h2>
                </div>

                {/* 2-Column Enterprise Bordered Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                    {approachData.map((item, index) => {
                        const stepNum = String(index + 1).padStart(2, '0');

                        return (
                            <motion.div
                                key={item.id || index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.45, delay: index * 0.08 }}
                                className="relative bg-white border border-[#D9E2EC] p-7 sm:p-9 min-h-[220px] flex flex-col justify-between overflow-hidden group transition-all duration-300 hover:shadow-[0_12px_32px_rgba(1,56,106,0.08)] hover:-translate-y-1"
                            >
                                <div>
                                    {/* Top Bar & Watermark Step Number */}
                                    <div className="flex items-center justify-between w-full mb-6">
                                        <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora leading-tight tracking-tight">
                                            {item.title}
                                        </h3>
                                        <span className="font-sora text-[22px] sm:text-[26px] font-bold text-[#01386A]/20 group-hover:text-[#01386A]/40 transition-colors duration-300 select-none">
                                            {stepNum}
                                        </span>
                                    </div>
                                    <div className="flex flex-col gap-3">
                                        {item?.desc?.map((point, i) => (
                                            <div key={i} className="flex items-start gap-3">
                                                <span className="w-1.5 h-1.5 rounded-full bg-[#ED6800] mt-2 shrink-0" />
                                                <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik font-[500] leading-[1.65]">
                                                    {point}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Bottom Border Accent (Navy to Orange hover) */}
                                <div className="absolute bottom-0 left-0 w-full h-[3px] bg-[#01386A]/15" />
                                <div className="absolute bottom-0 left-0 h-[3px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full" />
                            </motion.div>
                        );
                    })}
                </div>

            </div>
        </section>
    );
}

export default ApproachPointsSection;